import React from 'react';
import {OnChange} from 'react-final-form-listeners';
import {useIntl} from 'react-intl';

import Field from 'brandComponents/Form/Subcomponents/Field';

import {IExchangeFieldProps} from './IExchangeField';
import messages from './messages';

import styles from './ExchangeField.module.scss';

const ExchangeField = ({
	itemKey,
	exchangeReasonSelected,
	setExchangeReasonSelected,
}: IExchangeFieldProps) => {
	const intl = useIntl();

	return (
		<div className={styles['return-create-step-1__checkbox']}>
			<Field
				name={`exchangeProduct-${itemKey}`}
				type="checkbox"
				label={intl.formatMessage(messages.exchangeCheckboxLabel)}
				classNamesCntr={styles['return-create-step-1__checkbox']}
				classNames={styles['return-product__label']}
				component="input"
			/>
			<OnChange name={`exchangeProduct-${itemKey}`}>
				{(value) => {
					if (!value) {
						setExchangeReasonSelected({
							...exchangeReasonSelected,
							[itemKey]: '',
						});
					}
				}}
			</OnChange>

		</div>
	);
};

export default ExchangeField;